import { Badge } from 'react-bootstrap';
import { WASTE_PLAN_LIMITS, PPWR_PLAN_LIMITS } from '../../config/plans';

const STATUS_CONFIG = {
    trialing:  { label: 'Skúšobná verzia', variant: 'info' },
    active:    { label: 'Aktívne',          variant: 'success' },
    past_due:  { label: 'Po splatnosti',    variant: 'warning' },
    canceled:  { label: 'Zrušené',          variant: 'danger' },
};

const formatDate = (date) =>
    new Date(date).toLocaleDateString('sk-SK', { day: '2-digit', month: '2-digit', year: 'numeric' });

const daysLeft = (date) => {
    if (!date) return null;
    // Compare local calendar midnights, not raw timestamps: a day spanning a DST change is
    // 23 or 25 real hours, so dividing the raw ms difference by a fixed 24h would be off by
    // one around those transitions. Math.round absorbs that leftover hour either way.
    const end = new Date(date);
    const now = new Date();
    const endMidnight = new Date(end.getFullYear(), end.getMonth(), end.getDate());
    const nowMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const diff = Math.round((endMidnight - nowMidnight) / (1000 * 60 * 60 * 24));
    return diff > 0 ? diff : 0;
};

const SubscriptionStatus = ({ subscription, module = 'waste' }) => {
    if (!subscription) return null;

    const planLimits = module === 'ppwr' ? PPWR_PLAN_LIMITS : WASTE_PLAN_LIMITS;
    const status = STATUS_CONFIG[subscription.status] || STATUS_CONFIG.canceled;
    const planData = planLimits[subscription.plan];
    const endDate = subscription.status === 'trialing' ? subscription.trialEndsAt : subscription.currentPeriodEnd;
    const remaining = daysLeft(endDate);

    return (
        <div
            className="p-4 mb-4 rounded"
            style={{ backgroundColor: '#fff', border: '1px solid #EDF2F7' }}
        >
            <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                <div>
                    <p style={{ color: '#718094', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 4px' }}>
                        Aktuálny plán
                    </p>
                    <h5 style={{ color: '#0B1157', fontWeight: 700, margin: 0 }}>
                        {planData?.label ?? subscription.plan}
                    </h5>
                </div>
                <Badge bg={status.variant} style={{ fontSize: '13px', padding: '6px 12px' }}>
                    {status.label}
                </Badge>
            </div>

            <div className="mt-3 d-flex gap-4 flex-wrap">
                {subscription.status === 'trialing' && subscription.trialEndsAt && (
                    <div>
                        <p style={{ color: '#718094', fontSize: '12px', margin: '0 0 2px' }}>Skúšobná verzia do</p>
                        <p style={{ color: '#0B1157', fontWeight: 600, margin: 0 }}>
                            {formatDate(subscription.trialEndsAt)}
                        </p>
                    </div>
                )}

                {subscription.status !== 'trialing' && subscription.currentPeriodEnd && (
                    <>
                        <div>
                            <p style={{ color: '#718094', fontSize: '12px', margin: '0 0 2px' }}>Platné do</p>
                            <p style={{ color: '#0B1157', fontWeight: 600, margin: 0 }}>
                                {formatDate(subscription.currentPeriodEnd)}
                            </p>
                        </div>
                        {remaining !== null && (
                            <div>
                                <p style={{ color: '#718094', fontSize: '12px', margin: '0 0 2px' }}>Zostatok</p>
                                <p style={{ color: remaining <= 7 ? '#dc3545' : '#0B1157', fontWeight: 600, margin: 0 }}>
                                    {remaining} {remaining === 1 ? 'deň' : remaining < 5 ? 'dni' : 'dní'}
                                </p>
                            </div>
                        )}
                    </>
                )}

                {subscription.lastPaymentAt && (
                    <div>
                        <p style={{ color: '#718094', fontSize: '12px', margin: '0 0 2px' }}>Posledná platba</p>
                        <p style={{ color: '#0B1157', fontWeight: 600, margin: 0 }}>
                            {formatDate(subscription.lastPaymentAt)}
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SubscriptionStatus;
